import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const painPoints = [{
  icon: '😤',
  text: 'Comprás packs de planificaciones y cuando los abrís... son genéricos, hechos con IA mediocre y no sirven para tus alumnos reales'
}, {
  icon: '⏰',
  text: 'Pasás horas del domingo planificando cuando podrías estar con tu familia o simplemente descansando'
}, {
  icon: '💸',
  text: "Gastás en PDFs de 'especialistas' que son copias de ChatGPT mal hecho, vendidos a precio de oro"
}, {
  icon: '😰',
  text: 'Querés usar IA pero no sabés exactamente cómo pedirle lo que necesitás sin recibir basura genérica'
}, {
  icon: '📚',
  text: 'Reutilizás planificaciones viejas porque no tenés tiempo de crear material nuevo adaptado a tus alumnos'
}, {
  icon: '🔄',
  text: 'El ciclo no para: buscás, comprás, te decepcionás, repetís. Es agotador y costoso a largo plazo'
}];
export function PainSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-125">
      <div ref={ref} className={`max-w-[800px] mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-126">
        <div className="text-center mb-12" data-id="element-127">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-4" data-id="element-128">
            ¿TE SUENA FAMILIAR?
          </span>
          <h2 className="font-playfair font-bold text-3xl sm:text-[42px] leading-[1.2] text-navy" data-id="element-129">
            Sos Docente. Trabajás Más que Nadie. Y Seguís Pagando por Material
            que Termina en una Carpeta de Drive
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-130">
          {painPoints.map((point, index) => <div key={index} className="bg-white border border-[#E8EEF4] rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:border-gold hover:-translate-y-1 transition-all duration-300 flex flex-col items-center text-center group" data-id="element-131">
              <div className="text-[48px] mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-132">
                {point.icon}
              </div>
              <p className="font-inter text-[15px] text-gray-600 leading-relaxed" data-id="element-133">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-134">
          <p className="font-inter font-bold text-xl text-electric italic" data-id="element-135">
            "El problema no sos vos. Es que nadie te enseñó a usar la IA
            correctamente para tu trabajo real."
          </p>
        </div>
      </div>
    </section>;
}